import { ROLES } from "utils/helpers/enums/roles.enum";

export class LoginByGoogleDTO{
    accessToken: string = '';
    role: ROLES
    profileType: string = 'leader';

    constructor(data: Partial<LoginByGoogleDTO> = {}){
        Object.assign(this,data);
    }
}